import { Icon, symbolName } from './Icon'

type RemoveAccountIconProps = Readonly<{
  size?: number
  color?: string
}>

export function RemoveAccountIcon({
  size = 24,
  color = '#DD1818',
}: RemoveAccountIconProps) {
  return <Icon name={symbolName('trash', 'delete')} size={size} color={color} />
}
